import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  PsuElectSharedService,
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto,
} from '../../services/wealthlane-award-settlement-services';

const usePostPsuElectionMethod = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        PsuElectSharedService.postApiAwardSettlementApiAppPSUElectSaveElection(payload)
      );
    },
    {
      onSuccess: async (
        // eslint-disable-next-line camelcase
        response: Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined
      ) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message={`Election Method Added.`} />);
          void queryClient.invalidateQueries('getParticipantDashboardTaskSummery');
          void queryClient.invalidateQueries('getParticipantDashboardTask');
          navigate('/overview');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostPsuElectionMethod;
